import instance from "./instance";
//import dummyResponse from './dummyResponse';
import { buildErrorResponse } from "../../../components/errors/httpErrorPriority";

export default class Connector {
  searchEmail = (callback, specialization) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner",
      method: "get",
      params: {
        specialization: specialization,
      },
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        //console.log(response);
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({
              isError: true,
              ...response.data,
              httpStatus: response.status,
            });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // const status = e.response && e.response.status;
          // (e.response && e.response.data)
          // ? callback({
          //     isError: true,
          //     ...e.response.data,
          //     httpStatus: status,
          //   })
          // : callback({ isError: true, httpStatus: status });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  fetchAnswers = (callback, accountId, specialization) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/specialization/questionnaire",
      method: "get",
      params: {
        specialization: specialization,
      },
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, ...response.data });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          //   e.response && e.response.data
          //     ? callback({ isError: true, ...e.response.data })
          //     : callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  submit = (callback, body) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + body.accountId + "/specialization",
      method: "post",
      data: body,
      headers: headers,
    };
    // TO BE REMOVED
    // IF ERROR
    //throwError("We encountered an error. Please try again.");
    // IF SUCCESS
    //callback({"success" : true},props);
    //window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    instance
      .request(config)
      .then((response) => {
        //console.log(response);
        if (response.status === 200) {
          callback(response.data);
        } else {
          callback({ isError: true, ...response.data });
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          //   e.response && e.response.data
          //     ? callback({ isError: true, ...e.response.data })
          //     : callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };
  statusCheck = (callback, url) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: url,
      method: "get",
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, ...response.data });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          //   e.response && e.response.data
          //     ? callback({ isError: true, ...e.response.data })
          //     : callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };
}
